import React, { useContext } from "react";
import { ColorSelector } from "../../components/ColorSelector";
import { StoreContext } from "../../store/Store";
import { actionTypes } from "../../store/storeTypes";

const colours = [{ filter: "markerEndColor", display: "End Arrow" }];

const marginTop = 5;

const endType = ["Arrow","ArrowClosed"]

export const MarkersFilterPanel = () => {
  const [store, dispatch] = useContext(StoreContext);
  const { flowConfig } = store;

  const changefilter = (val, key) => {
    const newFilter = { ...flowConfig, [key]: val };

    dispatch({ type: actionTypes.SET_FLOWCONFIG, payload: newFilter });
    dispatch({ type: actionTypes.SET_NEWFLOWLAYOUTTRIGGER, payload: true });
  };

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        marginTop: 10,
        display: "block",
      }}
    >
      <div>

      <div
          style={{
            // display: "flex",
          }}
        >
          {endType.map((item, i) => {
            return (
              <div key={i}>
                <input
                  checked={item === flowConfig.markerEndType}
                  type="radio"
                  value={item}
                  name="markerEndType"
                  onChange={() => changefilter(item, "markerEndType")}
                />
                {item}
              </div>
            );
          })}
        </div>


        {/* markerEndHeight */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={0}
            max={60}
            value={flowConfig.markerEndHeight}
            onChange={(e) =>
              changefilter(e.target.valueAsNumber, "markerEndHeight")
            }
          />
          {`end height ${flowConfig.markerEndHeight}`}
        </div>
        {/* markerEndHWidth */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={0}
            max={60}
            value={flowConfig.markerEndHWidth}
            onChange={(e) =>
              changefilter(e.target.valueAsNumber, "markerEndHWidth")
            }
          />
          {`end width ${flowConfig.markerEndHWidth}`}
        </div>
      </div>
      <ColorSelector
        colours={colours}
        changefilter={changefilter}
        filter={flowConfig}
      />
    </div>
  );
};
